import { createSlice } from '@reduxjs/toolkit';

const courseSlice = createSlice({
	name: 'course',
	initialState: {
		loading: false,
		loadingCreateEdit: false,
		courses: [],
		courseSelected: [],
		courseListSelected: [],
		studentsNotInCourse: [],
	},
	reducers: {
		createCourseStart: (state) => {
			state.loadingCreateEdit = true;
		},
		createCourseSuccess: (state) => {
			state.loadingCreateEdit = false;
		},
		createCourseFailure: (state, action) => {
			state.loadingCreateEdit = false;
		},
		updateCourseStart: (state) => {
			state.loadingCreateEdit = true;
		},
		updateCourseSuccess: (state) => {
			state.loadingCreateEdit = false;
		},
		updateCourseFailure: (state, action) => {
			state.loadingCreateEdit = false;
		},
		getAllCoursesStart: (state) => {
			state.loading = true;
		},
		getAllCoursesSuccess: (state, { payload: { courses } }) => {
			state.loading = false;
			state.courses = courses;
		},
		getAllCoursesFailure: (state, action) => {
			state.loading = false;
		},
		getCourseByStart: (state) => {
			state.loading = true;
		},
		getCourseBySuccess: (state, { payload: { course } }) => {
			state.loading = false;
			state.courseSelected = course;
		},
		getCourseByIdentifierSuccess: (state, { payload: { students, course } }) => {
			state.loading = false;
			state.courseListSelected = students;
			state.courseSelected = course;
		},
		getCourseByFailure: (state, action) => {
			state.loading = false;
		},
		cleanSelectedCourse: (state, action) => {
			state.courseSelected = [];
			state.courseListSelected = [];
			state.studentsNotInCourse = [];
		},
		//List students by course
		getListStudentByIdCourseStart: (state) => {
			state.loading = true;
		},
		getListStudentByIdCourseSuccess: (state, { payload: { students } }) => {
			state.loading = false;
			state.courseListSelected = students;
		},
		getListStudentsNotCourseSuccess: (state, { payload: { students } }) => {
			state.loading = false;
			state.studentsNotInCourse = students;
		},
		getListStudentByIdCourseFailure: (state, action) => {
			state.loading = false;
		},

	},
});

export const {
    createCourseStart,
	createCourseSuccess,
    createCourseFailure,
    updateCourseStart,
	updateCourseSuccess,
    updateCourseFailure,
	getAllCoursesStart,
	getAllCoursesSuccess,
	getAllCoursesFailure,
	getCourseByStart,
	getCourseBySuccess,
	getCourseByIdentifierSuccess,
	getCourseByFailure,
	cleanSelectedCourse,
	getListStudentByIdCourseStart,
	getListStudentByIdCourseSuccess,
	getListStudentsNotCourseSuccess,
	getListStudentByIdCourseFailure,
} = courseSlice.actions;
export default courseSlice.reducer;